import RoomsSlider from '../modules/components/_rooms-slider';
// import RoomFacilitiesSlider from '../modules/components/_room-facilities-slider';
import OtherHotelsSlider from '../modules/components/_otherhotels-slider';
import RoomItemSlider from '../modules/components/_room-item-slider';
import LandingRoomItemSlider from '../modules/components/_landing-room-item-slider';
import RecognitionItemSlider from '../modules/components/_recognition-item-slider';
import ExperienceItemSlider from '../modules/components/_experience-item-slider';
import LandingFacilityItemSlider from '../modules/components/_landing-facility-item-slider';
import DinningItemSlider from '../modules/components/_dinning-item-slider';
import VenueItemSlider from '../modules/components/_venue-item-slider';
import GalleryItemSlider from '../modules/components/_gallery-item-slider';
import NearByItemSlider from '../modules/components/_near-by-item-slider';
import ArticleItemSlider from '../modules/components/_article-item-slider';
import OnePageHeader from '../modules/components/_one-page-header';
import HeroSlider from '../modules/components/_hero-slider';
import BrandSlider from '../modules/components/_brands-slider';
import VenueSlider from '../modules/components/_venue-slider';
import Map from '../modules/components/maps/_map';
// import bootstrap from 'bootstrap';

const Components = {
    init() {
        RoomsSlider.init();
        // RoomFacilitiesSlider.init();
        OtherHotelsSlider.init();
        LandingRoomItemSlider.init();
        RoomItemSlider.init();
        RecognitionItemSlider.init();
        NearByItemSlider.init();
        ArticleItemSlider.init();
        ExperienceItemSlider.init();
        LandingFacilityItemSlider.init();
        GalleryItemSlider.init();
        DinningItemSlider.init();
        VenueItemSlider.init();
        OnePageHeader.init();
        HeroSlider.init();
        BrandSlider.init();
        VenueSlider.init();
        Map.init();
        // bootstrap.init();
    },
    finalize() {

    },
};
export default Components;


// WEBPACK FOOTER //
// ./scripts/autoload/_components.js